import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import { getCountryByShortKey } from '@wix/locale-dataset-javascript';
import { COUNTRY_CODES, mapSubdivisionReplacedBy } from '@wix/form-multiline-address';
import { FIELD_TYPES } from '../../../constants';
import { useTranslation } from '../../../contexts/translation-context';
import { useAddressLabel } from '../../../hooks/use-address-label';
import { createOption } from '../../../ui/autocomplete/autocomplete';
import { DropdownAutocomplete } from '../../../ui/dropdown-autocomplete';
import { useCountryCode } from '../../multiline-address/multiline-address/country-code-context';
const MlaSubdivision = props => {
  const fieldType = FIELD_TYPES.MLA_SUBDIVISION;
  const {
    t
  } = useTranslation();
  const label = useAddressLabel('subdivision');
  const countryCode = useCountryCode();
  const countryCodeAlpha3 = countryCode ? COUNTRY_CODES[countryCode] : undefined;
  const country = countryCode && getCountryByShortKey(countryCode);
  const subdivisionOptions = useMemo(() => {
    var _country$subdivisions;
    const subdivisions = mapSubdivisionReplacedBy((country == null || (_country$subdivisions = country.subdivisions) == null ? void 0 : _country$subdivisions.list) || [], countryCodeAlpha3);
    return (subdivisions || []).map(subdivision => createOption({
      value: t(subdivision.displayName),
      id: subdivision.key
    })).sort((a, b) => a.value.localeCompare(b.value));
  }, [countryCodeAlpha3, t, country]);
  return /*#__PURE__*/React.createElement(DropdownAutocomplete, _extends({}, props, {
    fieldType: fieldType,
    label: label,
    options: subdivisionOptions,
    countryCode: countryCode
  }));
};
export default MlaSubdivision;
//# sourceMappingURL=mla-subdivision.js.map